// Shared filtering for searchable picker choices.
// Treats missing labels and search text as empty strings.
export function pickerChoices(options, q, cap = 50) {
  const needle = String(q ?? '').trim().toLowerCase();
  const choices = Array.isArray(options) ? options : [];
  return (needle
    ? choices.filter((o) => String(o?.label ?? '').toLowerCase().includes(needle))
    : choices
  ).slice(0, cap);
}
